import React, {FC} from "react"

import {TextModel} from "models/Text"
import FacetsPriceSelector from "../../facetsPriceSelector"
import connect from "./connect"
import {FilterFacet, FilterPrice} from "../../../models/Filter"
import {FiltersPanelContainer, PaddedWrapper} from "../components"
import {isPriceFilter} from "../../../models/Filter/typeGuards"
import ShowFiltersText from "../showFiltersText"
import FilterDetails from "../filterDetails"

interface Props {
    filter: FilterFacet | FilterPrice | null
    isFetchingPageItems?: boolean
    text: TextModel
    sortFiltersAlphabatically?: boolean
    compositeFilter: boolean
}

export const TabbedFiltersPanel: FC<Props> = ({
    filter,
    isFetchingPageItems,
    text,
    sortFiltersAlphabatically = false,
    compositeFilter,
}) => {
    if (!filter) return null

    if (isPriceFilter(filter)) {
        return (
            <FiltersPanelContainer data-testid="plp-tabbed-facets-panel">
                {!isFetchingPageItems ? (
                    <FacetsPriceSelector name={filter.name} isTabbedFilter />
                ) : (
                    <PaddedWrapper>
                        <ShowFiltersText>{text.labels.loadingResults}</ShowFiltersText>
                    </PaddedWrapper>
                )}
            </FiltersPanelContainer>
        )
    }

    return (
        <FilterDetails
            {...filter}
            showLoadingText={isFetchingPageItems}
            text={text}
            sortFiltersAlphabatically={sortFiltersAlphabatically}
            compositeFilter={compositeFilter}
        />
    )
}

export default connect(TabbedFiltersPanel)
